export const HeartIcon = ({ className }: { className?: string }) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor">
    <path
      d="M8.29266 14.8585C10.8627 12.4785 13.9227 10.2485 15.2827 6.90855C15.7727 5.42855 15.6327 3.71855 14.6627 2.46855C14.0927 1.71855 13.1627 1.16855 12.2127 1.04855C10.4227 0.738547 8.80266 1.94855 8.28266 3.66855C7.83266 2.32855 6.82266 1.24855 5.42266 1.05855C5.06266 1.00855 4.71266 0.998547 4.35266 1.05855C3.96266 1.10855 3.59266 1.22855 3.23266 1.39855C2.08266 1.93855 1.32266 3.07855 1.07266 4.30855C0.932664 5.16855 0.992664 6.07855 1.27266 6.90855C2.64266 10.2485 8.28266 14.8485 8.28266 14.8485L8.29266 14.8585Z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
